module.exports = __webpack_public_path__ + "img/Vinjeboka_Første-bilde-av-noen-som-blar-I-boka.17ff64a3.jpg";